import useAdd from "../../api/useAdd";

const useContact = () => {
  const {
    handleAdd: sendMessage,
    loading,
    error,
    isSuccess,
    SnackbarMessage,
  } = useAdd(
    "contact",
    localStorage.getItem("token"),
    "Message sent successfully!",
    "Failed to send message",
  );

  return {
    sendMessage,
    loading,
    error,
    isSuccess,
    SnackbarMessage,
  };
};

export default useContact;
